import { render, staticRenderFns } from "./ServerCreate.vue?vue&type=template&id=45178c86&scoped=true&"
import script from "./ServerCreate.vue?vue&type=script&lang=js&"
export * from "./ServerCreate.vue?vue&type=script&lang=js&"
import style0 from "./ServerCreate.vue?vue&type=style&index=0&id=45178c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45178c86",
  null
  
)

export default component.exports